import { render, staticRenderFns } from "./AditionalMaterial.vue?vue&type=template&id=0744e35f"
import script from "./AditionalMaterial.vue?vue&type=script&lang=js"
export * from "./AditionalMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports